// extracted by mini-css-extract-plugin
export default {"previewContainer":"Preview_previewContainer__1r3OZ","lectureTitle":"Preview_lectureTitle__p5NNq","lectureInfo":"Preview_lectureInfo__pc4vq"};